export default "__VITE_ASSET__DnJaSEgX__"